"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.InitFunction = void 0;
// ---------- import Packs
var react_1 = __importDefault(require("react"));
// ---------- default Function
var InitFunction = function (_a) {
    var children = _a.children, setFunction = _a.setFunction;
    // ----------- set Hooks
    var _b = react_1["default"].useState(false), sttCondShow = _b[0], setCondChildren = _b[1];
    // ----------- set Effects
    var fxInitData = function () {
        setFunction();
        setCondChildren(true);
    };
    react_1["default"].useEffect(fxInitData, []);
    // ----------- set Return
    return react_1["default"].createElement(react_1["default"].Fragment, null, sttCondShow && children);
};
exports.InitFunction = InitFunction;
